import React, { useState, useEffect } from 'react';
import './Transcript.css';

const KMFilterDash = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [transcriptdata, setTranscriptData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [submittedRange, setSubmittedRange] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [currentTranscript, setCurrentTranscript] = useState('');
    const [currentSessionid, setCurrentSessionid] = useState('');
    const [KMFilter, setKMFilter] = useState('all');
    const [isDataFetched, setIsDataFetched] = useState(false);  // New state to track if data is fetched
    const [openliveagent, setopenliveagent] = useState(false) //po-up
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const uniqueKMFilters = ["KMBotInfoUnAnswred", "KMBotInfoAnswred"]

    useEffect(() => {
        const handleScroll = () => {
            const footer = document.querySelector('footer');
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                footer.style.display = 'block';
            } else {
                footer.style.display = 'none';
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (!startDate || !endDate) return;

        const timer = setTimeout(() => {
            fetchFeedbackData(startDate, endDate, KMFilter);
            setSubmittedRange(`${startDate} - ${endDate}`);
        }, 1200);

        return () => clearTimeout(timer);
    }, [startDate, endDate, KMFilter]);


    const fetchFeedbackData = async (start, end, filter) => {
        let sendfilter;
        if (filter == "all") {
            sendfilter = ['KMBotInfoAnswred', 'KMBotInfoUnAnswred']
        } else if (filter == "KMBotInfoAnswred") {
            sendfilter = ['KMBotInfoAnswred']
        } else {
            sendfilter = ['KMBotInfoUnAnswred']
        }
        setIsLoading(true);
        try {
            const response = await fetch(`/api/kmfilter`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ start, end, filter: sendfilter }),
            });
            const result = await response.json();
            setTranscriptData(result.transcript);
            // const emails = result.transcript.map((trans) => trans.emailID);
            setIsDataFetched(true); // Set the flag when data is fetched
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsDataFetched(false); // If there's an error, reset the data flag
        } finally {
            setIsLoading(false);
        }
    };

    const formatTextWithBold = (text) => {
        const boldedText = text.replace(/\*\*(.*?)\*\*/g, (match, p1) => `<strong>${p1}</strong>`);
        const withParagraphs = boldedText.replace(/\n\n/g, '</p><p>');
        const formattedText = withParagraphs.replace(/\n/g, '<br />');
        return `<p>${formattedText}</p><br><br>`;
    };

    const handleSubmitDateRange = async () => {
        if (startDate && endDate) {
            setSubmittedRange(`${startDate} - ${endDate}`);
            fetchFeedbackData(startDate, endDate);
        } else {
            alert('Please select both start and end dates.');
        }
    };

    const handleShowTranscript = (trans) => {
        setCurrentTranscript(trans.transcript);
        setCurrentSessionid(trans.sessionid);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };


    // Filtered transcript data based on the email filter
    const filteredData = transcriptdata

    return (
        <>
            <h1 style={{ textAlign: "center" }}>KM Filter Dashboard</h1>
            <div className="container">
                <div className="datepickercontainer">
                    <div className="date-picker">
                        <div className="startdate">
                            <label htmlFor="start-date-picker">Start date:</label>
                            <input
                                type="date"
                                id="start-date-picker"
                                name="start-date-picker"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="enddate">
                            <label htmlFor="end-date-picker">End date:</label>
                            <input
                                type="date"
                                id="end-date-picker"
                                name="end-date-picker"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                    {/* <button onClick={handleSubmitDateRange}>Submit Date Range</button> */}
                </div>

                {/* Show email filter dropdown only if data is fetched */}
                {isDataFetched && (
                    <div className="email-filter">
                        <label htmlFor="email-filter">Filter by KM Category:</label>

                        <div className="custom-dropdown">
                            {/* Selected Value */}
                            <div
                                className="dropdown-selected"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                {KMFilter === "all" ? "All Category" : KMFilter}
                            </div>

                            {/* Dropdown */}
                            {isOpen && (
                                <div className="dropdown-menu">
                                    <div className="dropdown-options">
                                        {["all", "KMBotInfoUnAnswred", "KMBotInfoAnswred"].map((category, index) => (
                                            <div
                                                key={index}
                                                className="dropdown-option"
                                                onClick={() => {
                                                    setKMFilter(category);
                                                    setIsOpen(false);
                                                }}
                                            >
                                                {category === "all" ? "All Category" : category}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {isLoading && <p>Loading...</p>}

                <div className="feedbacks">
                    <div className="feedbackscontents">
                        <h2>Transcript</h2>
                        {submittedRange && <p>{submittedRange}</p>}
                        <div className="table-container">
                            <table className="feedback-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Username</th>
                                        <th>Email</th>
                                        <th>Transcript</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((trans, index) =>
                                            trans.transcript?.length > 1 ? (
                                                <tr key={index}>
                                                    <td>{trans.date}</td>
                                                    <td>{trans.name}</td>
                                                    <td>{trans.emailID}</td>
                                                    <td>
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                            <button onClick={() => handleShowTranscript(trans)}>
                                                                Interaction
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : null
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan={4}>No transcript available.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Modal for Transcript */}
                {showModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div className="modal-header">
                                Session ID : {currentSessionid}
                            </div>
                            <button className="close-modal" onClick={handleCloseModal}>
                                &times; Close
                            </button>
                            <div className="modal-transcript">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: formatTextWithBold(currentTranscript),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <footer>
                    <div className="footer-content">
                        <p></p>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default KMFilterDash
